import { is12HourClockFormat } from "./clockFormatPreference";

/** Same 12/24 preference as the navbar IST clock (default 12-hour). */
export function formatRefreshTimestamp(timestampMs, hour12 = is12HourClockFormat()) {
  if (timestampMs == null || Number.isNaN(Number(timestampMs))) return "";
  const d = new Date(Number(timestampMs));
  if (Number.isNaN(d.getTime())) return "";

  const parts = new Intl.DateTimeFormat(hour12 ? "en-US" : "en-GB", {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12,
  }).formatToParts(d);

  const get = (type) => parts.find((p) => p.type === type)?.value ?? "00";
  const time = `${get("hour")}:${get("minute")}:${get("second")}`;
  if (!hour12) return time;
  const period = (parts.find((p) => p.type === "dayPeriod")?.value ?? "").toUpperCase();
  return period ? `${time} ${period}` : time;
}
